import { type FC } from "react";

import { Tab } from "@snapchat/snap-design-system";

import { MetricField } from "../../../gql-generated/types";
import { formatPercentValue } from "../../formatters";
import { useInsightsPageBlizzardEvent } from "../../hooks";
import { ComputedMetricField, type InsightsMetricsMap, type StatsItem } from "../../models";
import { ChartSkeletonContainer } from "../ChartSkeletonContainer";
import { InsightsSubTabs } from "../InsightsSubTabs";
import { SubTabContent } from "../SubTabContent";
import { SubTabHeader } from "../SubTabHeader";
import { BarChartComponent } from "../charts";

interface ConversionTabProps {
    chartsMetrics: InsightsMetricsMap<StatsItem>;
    chartsMetricsComputed: InsightsMetricsMap<StatsItem>;
    loading: boolean;
}

export const ConversionTab: FC<ConversionTabProps> = ({ chartsMetrics, chartsMetricsComputed, loading }) => {
    useInsightsPageBlizzardEvent("MY_LENSES_INSIGHTS_CONVERSION");

    const swipeUpsMetric = chartsMetrics[MetricField.SwipeUps];
    const lensCTRMetric = chartsMetricsComputed[ComputedMetricField.LensCTR];

    return (
        <InsightsSubTabs>
            <Tab
                title={
                    <SubTabHeader
                        label="Total Clicks"
                        tooltip="The number of times your Lens Call-to-Actions have been clicked in Snapchat."
                        statValue={swipeUpsMetric?.totalValueFormatted ?? ""}
                        diffValue={swipeUpsMetric?.diffValue}
                        loading={loading}
                    />
                }
            >
                <SubTabContent>
                    <ChartSkeletonContainer skeletonActive={loading}>
                        {swipeUpsMetric && <BarChartComponent data={swipeUpsMetric} contentName="Clicks" />}
                    </ChartSkeletonContainer>
                </SubTabContent>
            </Tab>
            <Tab
                title={
                    <SubTabHeader
                        label="CTA Click Through Rate"
                        // TODO check tooltip value
                        statValue={lensCTRMetric?.valueOverTimeFormatted ?? ""}
                        diffValue={lensCTRMetric?.diffValue}
                    />
                }
            >
                <SubTabContent>
                    <ChartSkeletonContainer skeletonActive={loading}>
                        {lensCTRMetric && (
                            <BarChartComponent
                                data={lensCTRMetric}
                                contentName="Click Through Rate"
                                formatter={formatPercentValue()}
                            />
                        )}
                    </ChartSkeletonContainer>
                </SubTabContent>
            </Tab>
        </InsightsSubTabs>
    );
};
